<script lang="ts">
    import dayjs from 'dayjs';
    import { VpPriceTagIcon } from '@decathlon-experience/icons/svelte';
    import { parseDate } from '@internationalized/date';

    import { DateRange } from '$saga/utils/date';
    import {
        MinPriceDays,
        MinPriceMonth,
    } from '$saga/views/Tour/VisibleDates/types';
    import VisibleDatesDesktop from '$saga/views/Tour/VisibleDates/Fit/VisibleDatesDesktop.svelte';
    import VisibleDatesMobile from '$saga/views/Tour/VisibleDates/Fit/VisibleDatesMobile.svelte';
    import UnavailableTour from '$saga/views/Tour/VisibleDates/UnavailableTour.svelte';
    import AgeRangePricesDrawer from '$saga/views/Tour/VisibleDates/AgeRangePricesDrawer.svelte';
    import {
        isModalOpen,
        datesInfos,
        dateValue,
        modalStep,
        selectedPrice,
    } from '$saga/views/Tour/store';

    export let closedSales,
        dict,
        disabled: boolean,
        searchUrl: string,
        cheapestMonthlyPrices,
        cheapestDailyPrices: MinPriceDays,
        isBookable: boolean,
        circuitPricingBasePrices;

    let closedSalesFormatted: DateRange[];
    $: {
        const parsedClosedSales = JSON.parse(closedSales);
        closedSalesFormatted = parsedClosedSales.map(
            (closedSale: { startDate: string; endDate: string }) => {
                return {
                    startDate: dayjs(closedSale.startDate),
                    endDate: dayjs(closedSale.endDate),
                };
            },
        );
    }
    let minPricePerMonths: MinPriceMonth[] = [];
    // transform cheapestMonthlyPrices into an array of object container a dayjs date, and a number "price"
    $: {
        // key is the date
        minPricePerMonths = Object.keys(cheapestMonthlyPrices).map((key) => ({
            date: dayjs(key),
            price: cheapestMonthlyPrices[key]?.amount,
            quantile: cheapestMonthlyPrices[key]?.quantile,
        }));
    }

    const handleSelectedDate = (selectedDate: string) => {
        const date = dayjs(selectedDate).format('YYYY-MM-DD');
        const selected = date ? cheapestDailyPrices[date] : null;

        if (selected) {
            $selectedPrice = {
                originalPrice: selected.originalAmount
                    ? selected.originalAmount / 100
                    : null,
                rebateAmount: selected.rebateAmount
                    ? `-${selected.rebateAmount / 100}€`
                    : null,
                actualPrice: selected.amount / 100,
            };
            $dateValue = parseDate(date);
            $datesInfos = {
                price: selected.rebateAmount
                    ? selected.rebateAmount / 100
                    : (selected.originalAmount ?? 0) / 100,
                remainingStock: null,
                statusName: '',
                selectedDate: selectedDate,
            };
            $modalStep = 2;
            $isModalOpen = true;
        }
    };
</script>

<h2 class="pb-m text-[32px] font-semibold text-content-neutral">
    {dict.dates.title}
</h2>
<!-- If FIT is disabled -->
{#if disabled}
    <UnavailableTour {dict} {searchUrl} />
{:else}
    <div class="w-full bg-white p-s text-content-neutral desktop:p-m">
        <div class="flex flex-col gap-m">
            <h3 class="text-[22px] font-semibold">{dict.dates.start}</h3>
            <span class="text-center font-semibold">
                {dict.dates.months_select}
            </span>

            <!-- DESKTOP -->
            <div class="hidden desktop:block">
                <VisibleDatesDesktop
                    {minPricePerMonths}
                    minPricePerDays={cheapestDailyPrices}
                    closedSales={closedSalesFormatted}
                    {isBookable}
                    {handleSelectedDate}
                />
            </div>

            <!-- MOBILE -->
            <div class="desktop:hidden">
                <VisibleDatesMobile
                    {minPricePerMonths}
                    minPricePerDays={cheapestDailyPrices}
                    closedSales={closedSalesFormatted}
                    {isBookable}
                    {handleSelectedDate}
                />
            </div>

            {#if circuitPricingBasePrices.length > 1}
                <AgeRangePricesDrawer ageRangePrices={circuitPricingBasePrices}>
                    <div
                        slot="triggerlink"
                        class="flex cursor-pointer items-center gap-xs text-sm underline hover:no-underline"
                    >
                        <VpPriceTagIcon class="size-xl" />
                        {dict.dates.price_per_age}
                    </div>
                </AgeRangePricesDrawer>
            {/if}
        </div>
    </div>
{/if}
